<div class="app-content content bg-full-screen-image" *ngIf="isPageLoaded">
    <div class="content-wrapper">
      <div class="content-header row ">
      </div>
      <div class="content-body">
        <section class="row flexbox-container">
          <div class="col-12 d-flex align-items-center justify-content-center">
            <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
              <div class="card border-grey border-lighten-5 m-0 card-transparent">
                <div class="card-header border-0">
                  <div class="card-title text-center">
                    <img src="https://res.cloudinary.com/drtcnv1st/image/upload/v1679330333/Custom/logo-sate_by7hwg.png" alt="branding logo" width="60px" height="60px">
                    <br>
                    <h6 class="card-title title">Sistema de Seguimiento y <br>Apoyo de Trabajo a Egresados</h6>
                  </div>
                </div>
                <div class="card-content">
                  <br>
                  <h3 class="text-center card-title user">Registro Empresa</h3>
                  <h5 class="card-title text-muted text-center mx-2 my-2">Completa el siguiente formulario</h5>
                  <hr>
                  <div class="card-body">
                    <form class="form-horizontal" [formGroup]="registerCompanyForm" (ngSubmit)="tryRegister()">
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                          <fieldset class="form-group position-relative has-icon-left">
                            <input type="text" name="first_name" id="first_name" class="form-control"
                              tabindex="1" placeholder="Nombre de Responsable"
                              formControlName="first_name" 
                              [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }"
                               required>
                            <div class="form-control-position">
                              <i class="la la-smile-o icon dark"></i>
                            </div>
                            <div *ngIf="submitted && f.first_name.errors" class="invalid-feedback">
                              <div *ngIf="f.first_name.errors">Escribe el nombre de responsable</div>
                            </div>
                          </fieldset>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <fieldset class="form-group position-relative has-icon-left">
                            <input type="text" name="last_name" id="last_name" class="form-control"
                              placeholder="Apellido de Responsable" tabindex="2"
                              formControlName="last_name" 
                              [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }"
                               required
                              >
                            <div class="form-control-position">
                              <i class="la la-smile-o icon dark"></i>
                            </div>
                            <div *ngIf="submitted && f.last_name.errors" class="invalid-feedback">
                              <div *ngIf="f.last_name.errors">Escribe el apellido de responsable</div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <fieldset class="form-group position-relative has-icon-left">
                        <input type="text" name="username" id="username" class="form-control"
                          placeholder="Nombre de Usuario para Acceder" tabindex="3"
                          formControlName="username" 
                              [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
                               required
                          >
                        <div class="form-control-position">
                          <i class="la la-user icon icon-purple"></i>
                        </div>
                        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                          <div *ngIf="f.username.errors">Escribe el usuario</div>
                        </div>
                        <div class="help-block font-small-3"></div>
                      </fieldset>
                      <fieldset class="form-group position-relative has-icon-left">
                        <input type="text" autocomplete="username" name="companyName" id="companyName" class="form-control" placeholder="Nombre de Empresa o Grupo Empleador"
                          tabindex="4"
                          formControlName="companyName" 
                              [ngClass]="{ 'is-invalid': submitted && f.companyName.errors }"
                               required
                          >
                        <div class="form-control-position">
                          <i class="la la-building icon dark"></i>
                        </div>
                        <div *ngIf="submitted && f.companyName.errors" class="invalid-feedback">
                          <div *ngIf="f.companyName.errors">Escribe el nombre de la empresa</div>
                        </div>
                        <div class="help-block font-small-3"></div>
                      </fieldset>
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                          <fieldset class="form-group position-relative has-icon-left">
                            <input type="password" autocomplete="new-password" name="password" id="password" class="form-control"
                              placeholder="Contraseña" tabindex="5"
                              formControlName="password" 
                              [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                               required
                              >
                            <div class="form-control-position">
                              <i class="la la-key icon dark"></i>
                            </div>
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                              <div *ngIf="f.password.errors">Contraseña valida: (Mayúscula, minúscula y número)</div>
                            </div>
                            <div class="help-block font-small-3"></div>
                          </fieldset>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <fieldset class="form-group position-relative has-icon-left">
                            <input type="password" autocomplete="new-password" name="password_confirmation" id="password_confirmation"
                              class="form-control" placeholder="Confirmar contraseña" tabindex="6"
                              data-validation-matches-match="password"
                              formControlName="password_confirmation" 
                              [ngClass]="{ 'is-invalid': submitted && f.password_confirmation.errors }"
                               required>
                            <div class="form-control-position">
                              <i class="la la-key icon dark"></i>
                            </div>
                            <div *ngIf="submitted && f.password_confirmation.errors" class="invalid-feedback">
                              <div *ngIf="f.password_confirmation.errors?.mismatch">Las contraseñas no coinciden</div>
                            </div>
                            <div class="help-block font-small-3"></div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-4 col-sm-3 col-md-3">
                          <div class="custom-control custom-checkbox mb-1">
                            <input type="checkbox" [(ngModel)]="check" formControlName="check" id="idCheck" class="custom-control-input" >
                            <label class="custom-control-label" for="idCheck">Estoy de acuerdo</label>
                          </div>
                        </div>
                        <div class="col-8 col-sm-9 col-md-9">
                          <p class="font-small-4">Los datos de la empresa serán usados unicamente con el fin de beneficiar
                            a la misma y a los egresados que buscan formar parte de su equipo de trabajo.
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                          <button type="submit" [disabled]="!check" class="btn btn-info btn-block btn-round"><i class="feather ft-user"></i>
                            Crear cuenta</button>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <a [routerLink]="['/login-empresa']" class="btn btn-dark btn-block btn-round"><i
                              class="feather ft-unlock"></i>
                            Iniciar Sesión</a>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row"><br><br><br><br><br><br></div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <!-- <app-public-footer></app-public-footer> -->
  